<template>
	<div :class="{ 'is-active': active }" class="modal">
		<div class="modal-background" @click="$emit('close')" />
		<div class="modal-card">
			<header class="modal-card-head">
				<slot name="header">
					<p v-if="title" class="modal-card-title">
						{{ title }}
					</p>
				</slot>
			</header>
			<section class="modal-card-body">
				<slot />
			</section>
			<footer class="modal-card-foot">
				<slot name="footer" />
			</footer>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DpModal',
	props: {
		title: { type: String, default: null },
		active: { type: Boolean, default: false },
	},
};
</script>
